import moment from 'moment'
import { personType, IncomFreqency, personModal, childIncomeTypeList, incomeModal } from '../../Parent/SchoolLunchBreakfastProgram/schoolLunchBreakfastModal'
import { date_format } from '../../../server/constants';
export const buildApplication = (appData, enableConfirmingOfficial) => {
    let mainDev = document.createElement('div');
    let title = document.createElement('div');
    let heading = document.createElement('h3');
    heading.innerHTML = "Household Application for Free and Reduced Price School Meals";
    heading.style.color = 'red';
    heading.style.textAlign = 'center';
    title.appendChild(heading);
    mainDev.appendChild(title);

    let appNo_date = document.createElement('div');
    let leftDiv = document.createElement('div')
    leftDiv.style.cssFloat = 'left';
    leftDiv.style.maxWidth = '50%';
    leftDiv.innerHTML = '<p>Application Id:<strong>' + ("00000" + appData.applicationId).slice(-5) + '</strong></p>';
    appNo_date.appendChild(leftDiv);

    let rightDiv = document.createElement('div')
    rightDiv.style.cssFloat = 'right';
    rightDiv.style.textAlign = 'right';
    rightDiv.style.maxWidth = '50%';
    rightDiv.innerHTML = '<p>Date: <strong>' + moment(appData.date, 'MMDDYYYY').format('YYYY-MM-DD') + '</strong></p>';
    appNo_date.appendChild(rightDiv);
    mainDev.appendChild(appNo_date);

    let childDiv = document.createElement('div')
    let childTable = '<table width="100%" border=1 style="border-collapse: collapse; border: 1px solid #ddd; font-size:12px">'
    let childHead = '<thead><tr>' +
        '<th rowspan="2" style="width:25%">First Name</th>' +
        '<th rowspan="2" style="width:25%">Last Name</th>' +
        '<th rowspan="2" style="width:10%">Grade</th>' +
        '<th colspan="2" style="width:20%">Student?</th>' +
        '<th rowspan="2" style="width:10%">Foster Child</th>' +
        '<th rowspan="2" style="width=10%">Homeless, Migrant, Runaway, Head Start</th>' +
        '</tr><tr>' +
        '<th>Yes</th>' +
        '<th>No</th>' +
        '</tr></thead>';
    let childStudents = '';
    const parent = appData.householdAppInfo.find(rec => {
        return rec.personType === personType.adult && rec.contact
    }) || {};
    appData.householdAppInfo.map((student) => {
        if (student.personType === personType.student) {
            let homelessString = '';
            let homelessArray = [];
            if (student.mcKinneyVentoHomeless) {
                homelessArray.push('Homeless');
            }
            if (student.migrantEducationPrg) {
                homelessArray.push('Migrant');
            }
            if (student.runaway) {
                homelessArray.push('Runaway');
            }
            if (student.headStart) {
                homelessArray.push('Head Start');
            }
            if (homelessArray.length > 0) {
                (homelessArray || []).map(itm => {
                    homelessString = homelessString + '<span>&#10003;</span> <span>' + itm + '</span><br />';
                });
            }
            childStudents = childStudents + '<tr><td>' + student.fname + '</td>' +
                '<td>' + student.lname + '</td>' +
                '<td>' + student.grade + '</td>' +
                '<td style="text-align:center">' + (student.personType === personType.student ? '<span>&#10003;</span>' : '') + '</td>' +
                '<td style="text-align:center">' + (student.personType !== personType.student ? '<span>&#10003;</span>' : '') + '</td>' +
                '<td style="text-align:center">' + (student.liveUnderFosterCare ? '<span>&#10003;</span>' : '') + '</td>' +
                '<td style="text-align:center">' + homelessString + '</td></tr>';
        }
    });
    let childs = '';
    appData.householdAppInfo.map((student) => {
        if (student.personType === personType.child) {
            let homelessString = '';
            let homelessArray = [];
            if (student.mcKinneyVentoHomeless) {
                homelessArray.push('Homeless');
            }
            if (student.migrantEducationPrg) {
                homelessArray.push('Migrant');
            }
            if (student.runaway) {
                homelessArray.push('Runaway');
            }
            if (student.headStart) {
                homelessArray.push('Head Start');
            }
            if (homelessArray.length > 0) {
                (homelessArray || []).map(itm => {
                    homelessString = homelessString + '<span>&#10003;</span> <span>' + itm + '</span><br />';
                });
            }
            childs = childs + '<tr><td>' + student.fname + '</td>' +
                '<td>' + student.lname + '</td>' +
                '<td>' + student.grade + '</td>' +
                '<td style="text-align:center">' + (student.personType === personType.student ? '<span>&#10003;</span>' : '') + '</td>' +
                '<td style="text-align:center">' + (student.personType !== personType.student ? '<span>&#10003;</span>' : '') + '</td>' +
                '<td style="text-align:center">' + (student.liveUnderFosterCare ? '<span>&#10003;</span>' : '') + '</td>' +
                '<td style="text-align:center">' + homelessString + '</td></tr>'
        }
    });
    let programDev = document.createElement('div');
    let programLbl = '<p style="font-size: 12px;"><strong>Do any Household Members (including you) currently participate in one or more of the following assistance programs: SNAP, TANF, or FDPIR?</p><table width="100%" border=1 style="border-collapse: collapse; border: 1px solid #ddd; font-size:12px">';
    let programList = '';
    (appData.householdAppInfo[0].assistancePrograms || []).map((program, p) => {
        programList = programList + '<tr style="font-size: 12px;"><td style="width:50%"><strong>' + program.name + ' :</strong></td><td><label>' + program.caseNumber + '</label></td></tr></tr>'
    })
    programDev.innerHtml = programLbl + programList + '</table>';

    let incomeDev = document.createElement('div');

    let incomeBody = '';
    let isIncomeExist = appData.householdAppInfo.some((person) => {
        return person.income.length > 0;
    });
    if (isIncomeExist) {
        let incomeHeader = '<p style="font-size:14px;  margin:5px 0px;"><strong>Report Income for ALL Household Members</strong></p><table width="100%" border=1 style="border-collapse: collapse; border: 1px solid #ddd; font-size:12px">' +
            '<tr><th rowspan="2">Name</th><th colspan="3" style="text-align:center;">Income ($)</th></tr><tr><th>Source</th><th>Frequency</th><th>Amount ($)</th></tr>';
        appData.householdAppInfo.map((person) => {
            if (person.income.length > 0) {
                incomeBody = incomeBody + '<tr><td rowspan=' + (person.income.length + 1) + '>' + person.fname + ' ' + person.lname + '</td><td colspan="3" style="padding:0; border:0;"></td></tr>'
                person.income.map(income => {
                    incomeBody = incomeBody + '<tr><td>' + income.source + '</td><td>' + getFrequencyName(income.frequency) + '</td><td>' + income.amount + '</td></tr>'
                })
            }
        })
        incomeDev.innerHTML = incomeHeader + '<tbody>' + incomeBody + '</tbody>' + '</table>';
    }
    const contact = parent.contact || {};

    let addressDev = '<p style="font-size:14px;  margin:5px 0px;"><strong>Contact information</strong></p>' +
        '<table width="100%" style="font-size:12px"><tr><td><span><strong>Email :</strong></span><span> ' + contact.email +
        '</span></td><td><span><strong>Phone :</strong></span><span> ' + contact.phone +
        '</span></td><td><span><strong>Address 1 :</strong></span><span> ' + contact.street1 + '</span></td></tr>' +
        '<tr><td><span><strong>Address 2 :</strong></span><span> ' + contact.street2 +
        '</span></td><td><span><strong>City :</strong></span><span> ' + contact.city + '</span></td>' +
        '<td><span><strong>State :</strong></span><span> ' + contact.state + '</span></td></tr>' +
        '<tr><td><span><strong>Zip :</strong></span><span> ' + contact.zip + '</span></td><td></td><td></td></tr>' +
        '</table>';
    let ssnDev = '<p style="font-size:12px"><strong>Last Four Digits of Social Security Number (SSN) of Primary Wage Earner or Other Adult Household Member</strong>' +
        ': ' + (parent.noSSN === true ? 'No SSN' : parent.ssn) + '</p>';

    let racialDev = "<p style='font-size:14px;  margin:5px 0px;'><strong>Children's Racial and Ethnic Identities</strong></p>";
    racialDev = racialDev + '<table border=1 width="100%" style="border-collapse: collapse; border: 1px solid #ddd;font-size:12px"><tr><th style="width:25%">Name</th><th style="width:25%">Ethnicity</th><th>Race</th></tr>'
    appData.householdAppInfo.map((student) => {
        if (student.personType === personType.student) {
            racialDev = racialDev + '<tr><td>' + student.fname + ' ' + student.lname +
                '</td><td>' + student.ethenticity + '</td><td>' + student.race.join(', ') + '</td></tr>'
        }
    });
    racialDev = racialDev + '</table>';
    const totInc = getTotalIncome(appData.householdAppInfo);
    let houseHoldDiv = '<p style="font-size:12px; margin:5px 0px;"><span><strong>Total Household Income (per ' + (totInc.frequency || '') + ') ($) : </strong></span><span>' + totInc.amount + '</sp></p>' +
        '<p style="font-size:12px; margin:5px 0px;"><span><strong>Total Household Size : </strong></span><span>' + appData.householdAppInfo.length + '</span></p>';
    let eligibilityDev = '<p style="font-size:14px;  margin:5px 0px;"><strong>Student Eligibility</strong></p><ul style="list-style: none; font-size:12px">'
    appData.householdAppInfo.map((student) => {
        if (student.personType === personType.student) {
            const statusUpdatedDate = moment(appData.statusUpdateDate).isValid() ? moment(appData.statusUpdateDate).format(date_format() + ' hh:mm:ss') : ''
            eligibilityDev = eligibilityDev + '<li><span style="width:200px; display:inline-block">' + student.fname + ' ' + student.lname + '</span> : ' + (student.isFreeMeal === true ? 'Free' : (student.isFreeMeal === false ? 'Reduced' : 'Regular')) + '<span style="font-size:12px"> [ Updated On :' + statusUpdatedDate + ']</span></li>'
        }
    });
    eligibilityDev = eligibilityDev + '</ul>';

    let reasonsDev = ''
    let rejectStatus = (appData.householdAppInfo.some((student) => {
        return student.personType === personType.student && student.isFreeMeal === null
    }))
    if (rejectStatus) {
        // normalize declinedReasonList to an array even if stored as JSON string
        let declList = [];
        const rawDecl = appData.declinedReasonList;
        if (Array.isArray(rawDecl)) {
            declList = rawDecl;
        } else if (typeof rawDecl === 'string' && rawDecl.trim() !== '') {
            try {
                declList = JSON.parse(rawDecl);
            } catch (e) {
                console.warn('Failed to parse declinedReasonList JSON', e);
                declList = [];
            }
        }
        //reasonsDev=reasonsDev+'<p style="font-size:14px;  margin:5px 0px;"><strong>Reason for decline</strong></p><ul style="list-style: none; font-size:12px">';
        // if(appData.declinedReasonList[0].isApplicable===true){
        //     reasonsDev=reasonsDev+'<li> <span>&#10003;</span>'+appData.declinedReasonList[0].name+'</li>'
        // }
        // if(appData.declinedReasonList[1].isApplicable===true){
        //     reasonsDev=reasonsDev+'<li> <span>&#10003;</span>'+appData.declinedReasonList[1].name+'</li>'
        // }
        // if(appData.declinedReasonList[2].isApplicable===true){
        //     reasonsDev=reasonsDev+'<li> <span>&#10003;</span>'+appData.declinedReasonList[2].name+'<p style="font-size:12px; font-style: italic margin:5px 20px; ">'+appData.declinedReasonList[2].description+'</p></li>'
        // }
        // if(appData.declinedReasonList[3].isApplicable===true){
        //     reasonsDev=reasonsDev+'<li> <span>&#10003;</span>'+appData.declinedReasonList[3].name+'<p style="font-size:12px; font-style: italic; margin:5px 20px; ">'+appData.declinedReasonList[3].description+'</p></li>'
        // }
        // reasonsDev=reasonsDev+'</ul>';  
        // const declList = Array.isArray(appData.declinedReasonList) ? appData.declinedReasonList : [];
        if (declList.length > 0) {
            reasonsDev += '<p style="font-size:14px;  margin:5px 0px;"><strong>Reason for decline</strong></p><ul style="list-style: none; font-size:12px">';
            declList.forEach(reason => {
                if (reason && reason.isApplicable === true) {
                    reasonsDev += '<li> <span>&#10003;</span>' + (reason.name || '');
                    if (reason.description) {
                        reasonsDev += '<p style="font-size:12px; font-style: italic; margin:5px 20px;">' + reason.description + '</p>';
                    }
                    reasonsDev += '</li>';
                }
            });
            reasonsDev += '</ul>';
        }
    }

    let applicentDev = '<div style="padding:10px; float:right"><p style="text-align:left;margin: 2; padding-bottom:5px; font-size: 14px;">Submitted By,</p>' +
        '<strong style="text-align: left;display: block;font: 16px bold;text-transform: uppercase;">' + appData.householdAppInfo[0].fname + ' ' + appData.householdAppInfo[0].lname + '</stro>'
        + '<span style="text-align: left;display: block;font: 13px italic;">Date :' + moment(appData.date, 'MMDDYYYY').format('YYYY-MM-DD HH:MM:SS') + '</span></div>';
    const signatureDev = enableConfirmingOfficial ? `<div style="padding:10px;"><table width="100%" colSpan="2" rowSpan="2">
    <tr>
        <td style="text-align:center; height: 1.7em; border:1px solid #ddd;"><span>${appData.determineOfficialFirstName || ''} ${appData.determineOfficialLastName || ''}</span></td>
        <td style="text-align:center; height: 1.7em;border:1px solid #ddd; width:90px;"><span>${appData.determineDate ? new Date(appData.determineDate).toLocaleDateString() : ''}</span></td>
        <td style="text-align:center; height: 1.7em;border:1px solid #ddd;">
         <span>${appData.confirmOfficialFirstName || ''} ${appData.confirmOfficialLastName || ''}</span> 
        </td>
        <td style="text-align:center; height: 1.7em;border:1px solid #ddd; width:90px">
           <span>${appData.confirmDate ? new Date(appData.confirmDate).toLocaleDateString() : ''}</span>
        </td>
        <td style="text-align:center; height: 1.7em;border:1px solid #ddd;"><span>${appData.verifyingOfficial || ''}</span></td>
        <td style="text-align:center; height: 1.7em;border:1px solid #ddd; width:90px;"><span>${appData.verifyingOfficialDate || ''}</span></td>
        </tr>    
    <tr>
        <td style="text-align:center; font-size:12px;"><span>Determining Official Signature</span></td>
        <td style="text-align:center; font-size:12px;"><span>Date</span></td>
        <td style="text-align:center;font-size:12px;">
           <span>Confirming Official Signature</span> 
        </td>
        <td style="text-align:center; font-size:12px;">
           <span>Date</span>
        </td>
        <td style="text-align:center;font-size:12px;"><span>Verifying Official Signature</span></td>
        <td style="text-align:center;font-size:12px;"><span>Date</span></td>
        </tr>
        
        </table></div>`: `<div style="padding:10px;"><table width="100%" colSpan="2" rowSpan="2">
    <tr>
        <td style="text-align:center; height: 1.7em; border:1px solid #ddd;"><span>${appData.determineOfficialFirstName || ''} ${appData.determineOfficialLastName || ''}</span></td>
        <td style="text-align:center; height: 1.7em;border:1px solid #ddd; width:90px;"><span>${appData.determineDate ? new Date(appData.determineDate).toLocaleDateString() : ''}</span></td>
        <td style="text-align:center; height: 1.7em;border:1px solid #ddd;" colspan="2" width="200px">
         <span>&nbsp;</span> 
        </td>
        
        
        <td style="text-align:center; height: 1.7em;border:1px solid #ddd;"><span>${appData.verifyingOfficial || ''}</span></td>
        <td style="text-align:center; height: 1.7em;border:1px solid #ddd; width:90px;"><span>${appData.verifyingOfficialDate || ''}</span></td>
        </tr>    
    <tr>
        <td style="text-align:center; font-size:12px;"><span>Determining Official Signature</span></td>
        <td style="text-align:center; font-size:12px;"><span>Date</span></td>
        <td style="text-align:center;font-size:12px;" colspan="2" width="200px">
           <span>&nbsp;</span> 
        </td>
       
        <td style="text-align:center;font-size:12px;"><span>Verifying Official Signature</span></td>
        <td style="text-align:center;font-size:12px;"><span>Date</span></td>
        </tr>
        
        </table></div>`;
    childDiv.innerHTML = childTable + childHead +
        '<tbody>' + childStudents + childs +
        '</tbody></table>' + programDev.innerHtml + incomeDev.innerHTML +
        addressDev + ssnDev + racialDev + houseHoldDiv
        + (appData.status == 'approved' || appData.state == 'declined' ? eligibilityDev + reasonsDev : '') + (signatureDev) + applicentDev;
    mainDev.appendChild(childDiv);

    return mainDev.outerHTML
}
const getFrequencyName = (freq) => {
    let frequency = IncomFreqency.find(inf => {
        return inf.value == freq;
    });
    return ((frequency || {}).text || '');
}
const getAnnualIncome = (Income) => {
    let amount = 0.00;
    Income.map(inc => {
        amount = amount + (parseInt(inc.frequency) * parseFloat(inc.amount))
    });
    return amount;
}
const userTotIncome = (Income) => {
    let amount = 0.00;
    Income.map(inc => {
        amount = amount + (parseFloat(inc.amount))
    });
    return amount;
}
const getTotalIncome = (students) => {
    let amount = 0.00;
    let income = [];
    students.map(st => {
        if (st.income.length > 0) {
            const lst = st.income;
            income = [...income, ...lst];
        }
    });
    const freq = income.length > 0 ? income[0].frequency : 0;
    const res = income.every(inc => {
        return inc.frequency == freq;
    });
    students.map((student) => {
        amount = amount + (res ? userTotIncome(student.income) : getAnnualIncome(student.income));
    });

    return {
        amount: amount,
        frequency: res ? getFrequencyName(freq) : 'annum'
    };
}

export const schoolLunchAppPrint = (appData, enableConfirmingOfficial) => {
    let frame1 = document.createElement('iframe');
    frame1.name = "frame1";
    frame1.style.position = "absolute";
    frame1.style.top = "-1000000px";
    document.body.appendChild(frame1);
    let frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
    frameDoc.document.open();
    frameDoc.document.write('<html><head><title>Meal Manage</title>');
    frameDoc.document.write('</head><body>');
    frameDoc.document.write(buildApplication(appData, enableConfirmingOfficial));
    frameDoc.document.write('</body></html>');
    frameDoc.document.close();
    setTimeout(() => {
        window.frames["frame1"].focus();
        window.frames["frame1"].print();
        document.body.removeChild(frame1);
    }, 500);
}
export const printBlobFile = (blob) => {
    let objFra = document.createElement('iframe');     // Create an IFrame.
    objFra.style.visibility = 'hidden';                // Hide the frame.
    objFra.src = URL.createObjectURL(blob);                   // Set source.
    document.body.appendChild(objFra);  // Add the frame to the web page.
    objFra.contentWindow.focus();       // Set focus.
    objFra.contentWindow.print();
}



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SchoolMealProgram/schoolLunchAppForPrint.js